import {useEffect, useState} from "react";

const useDelayedClose = (isOpen, delay = 200) => {
	const [shouldRender, setShouldRender] = useState(isOpen);
	const [isClosing, setIsClosing] = useState(false);

	useEffect(() => {
		if (isOpen) {
			setShouldRender(true);
			setIsClosing(false);
		} else if (shouldRender) {
			setIsClosing(true);
			const t = setTimeout(() => {
				setShouldRender(false);
				setIsClosing(false);
			}, delay);
			return () => clearTimeout(t);
		}
	}, [isOpen]);

	return {shouldRender, isClosing};
};

export default useDelayedClose;